import React from "react";
import { InputStakeholderDialogInitialState, PageNewState } from ".";

export const InputStakeholderDialogContext = React.createContext({
  pageState: InputStakeholderDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
